import { inject, Injectable } from '@angular/core';
import { BaseWorkflowStateService } from '../../base-workflow-state.service';
import { ServiceLevelSelectionData } from '../../../../../../../models/order/workflow/alternate-shipping-address.model';
import { WirelessFlowStateService } from '../wireless-flow-state.service';


@Injectable({ providedIn: 'root' })
export class ServiceLevelSelectionStateService extends BaseWorkflowStateService<ServiceLevelSelectionData> {
    private flowStateService = inject(WirelessFlowStateService);
    override stateKey: string = 'serviceLevelSelection';
    public readonly serviceLevelCustomizationSubGroupName: string = 'Shipping'.toLocaleLowerCase();
    protected override saveLocalDraft(): void {
        this.flowStateService.updateData({ [this.stateKey]: this.state() });
    }

    getSelectedShippingMethod() {
        const state = this.state();
        if (state.choiceCode) {
            const choice = state.shipMethods?.find(m => m.Code === state.choiceCode);
            return choice;
        }
        return null;
    }

    getSelectedShippingChoice() {
        const state = this.state();
        if (state.choiceCode) {
            return state.customization?.Choices?.Choice.find(c => c.ChoiceCode === state.choiceCode);
        }
        return null;
    }

    getSelectedShippingMethodName() {
        return this.getSelectedShippingChoice()?.Name;
    }

    getSelectedShippingEstimatedDelivery() {
        return this.getSelectedShippingMethod()?.EstDeliveryDate;
    }
}